// Mixin dùng chung cho tra cứu thông tin doanh nghiệp theo mã số thuế (admin).
// Gọi qua proxy nội bộ (/tax-code/lookup) — có cache, không gọi thẳng VietQR từ browser.
// lookupTaxCode() KHÔNG bao giờ throw: luôn resolve { ok, data, message }.
export default {
  methods: {
    // Cảnh báo khi DN không còn hoạt động (để nhắc admin trước khi duyệt KYC / xuất hoá đơn).
    taxStatusWarning(data) {
      if (data && data.status && data.status.indexOf('đang hoạt động') === -1) {
        return 'Cảnh báo: doanh nghiệp ' + data.status;
      }
      return null;
    },
    // Validate định dạng MST (10 hoặc 13 số) — chặn gọi API cho input rác.
    mstValid(code) {
      const c = String(code == null ? '' : code).trim().replace(/[\s.\-]/g, '');
      return /^\d{10}$/.test(c) || /^\d{13}$/.test(c);
    },
    async lookupTaxCode(code) {
      if (!code || !code.toString().trim()) {
        return { ok: false, data: null, message: null };
      }
      if (!this.mstValid(code)) {
        return { ok: false, data: null, message: 'Mã số thuế không hợp lệ (phải là 10 chữ số).' };
      }
      try {
        const res = await this.$service.get('/tax-code/lookup', { params: { code: code.toString().trim() } });
        const body = res && res.data ? res.data : {};
        if (body.code === '00' && body.data) {
          return { ok: true, data: body.data, message: null };
        }
        return { ok: false, data: null, message: body.desc || 'Không tra cứu được mã số thuế.' };
      } catch (e) {
        return { ok: false, data: null, message: 'Không thể tra cứu mã số thuế. Vui lòng thử lại.' };
      }
    }
  }
};
